<main class="app-container">
  <router-outlet></router-outlet>

  <app-fullscreen-loader></app-fullscreen-loader>
</main>

<app-error-modal></app-error-modal>
